import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.customsTariffNoColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.customsTariffNoColumnHeader,
  name,
  render: (data) => data.customsTariffNo || '',
};
